
const SuperAdmin_Entitlement = 900;
const ToolsAdmin_Entitlement = 500;
const StoreAdmin_Entitlement = 400;
const UserInternal_Entitlement = 200;
const UserExternal_Entitlement = 100;

export const UserRole = {
    SuperAdmin_Entitlement,
    ToolsAdmin_Entitlement,
    StoreAdmin_Entitlement,
    UserInternal_Entitlement,
    UserExternal_Entitlement,
}